export default __webpack_public_path__ + "static/media/Logo.e87124e2.svg";